import React from 'react';

import { block } from 'bem-cn';

import { LANGUAGES } from '../../constants';
import useLocalizedStrings from '../../hooks/useLocalizedStrings';

import './card-content.scss';

const translations = {
  [LANGUAGES.EN]: {
    relatedCardsTitle: 'Tagged with',
  },
  [LANGUAGES.SV]: {
    relatedCardsTitle: 'Taggat med',
  },
};

const b = block('card-content');

type CardContentPropsType = {
  cardTitle?: string;
  hasCardPions: boolean;
  renderPions?: () => React.ReactNode;
  renderCardPions?: () => React.ReactNode;
  renderActionPions?: () => React.ReactNode;
  renderPendingPions?: () => React.ReactNode;
  renderTipPions?: () => React.ReactNode;
  renderPionsNotInCard?: () => React.ReactNode;
  renderPionsNotInCardWithOneHome?: () => React.ReactNode;
  renderPionsWithHomerBadge?: () => React.ReactNode;
  lang?: string;
};

const CardContent = ({
  cardTitle = '',
  lang = LANGUAGES.EN,
  hasCardPions = false,
  renderPions,
  renderCardPions,
  renderActionPions,
  renderPendingPions,
  renderTipPions,
  renderPionsNotInCard,
  renderPionsNotInCardWithOneHome,
  renderPionsWithHomerBadge,
}: CardContentPropsType) => {
  const strings = useLocalizedStrings(translations, lang);

  return (
    <div className={b()}>
      <div className={b('section')}>
        {renderActionPions && renderActionPions()}
        {renderPendingPions && renderPendingPions()}
        {renderTipPions && renderTipPions()}
        {renderPions && renderPions()}
        {renderPionsNotInCard && renderPionsNotInCard()}
        {renderPionsNotInCardWithOneHome && renderPionsNotInCardWithOneHome()}
        {renderPionsWithHomerBadge && renderPionsWithHomerBadge()}
      </div>

      {renderCardPions && hasCardPions && (
        <div className={b('section')}>
          <h2 className={b('title')}>
            {strings.relatedCardsTitle} {cardTitle}
          </h2>
          {renderCardPions()}
        </div>
      )}
    </div>
  );
};

export default CardContent;
